export interface SiteTotalsDTO {
  totalSignups: number;
  totalLiveListings: number;
}
